import { motion } from "framer-motion";
import { Globe, MapPin, CreditCard, PiggyBank } from "lucide-react";

const stats = [
  { icon: PiggyBank, title: "Buget de student, beneficii serioase", text: "Cu reducerile BRD-ISIC poți economisi chiar și peste 8.000 lei pe an." },
  { icon: Globe, title: "130+ țări", text: "ISIC este prezent la nivel internațional și recunoscut în întreaga lume." },
  { icon: MapPin, title: "140.000+ locații", text: "Ai acces la reduceri și beneficii în România și în străinătate." },
  { icon: CreditCard, title: "2 în 1", text: "Card bancar BRD și legitimație internațională ISIC, într-un singur card." },
];

export const StatsBar = () => (
  <section className="bg-zinc-50 border-y border-zinc-200 py-16 md:py-20" data-testid="stats-bar">
    <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((s, i) => (
        <motion.div
          key={s.title}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: i * 0.1 }}
          data-testid={`stat-card-${i}`}
          className="bg-white rounded-2xl border border-zinc-200 p-6 hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300"
        >
          <div className="w-11 h-11 rounded-xl bg-brand/10 flex items-center justify-center mb-4">
            <s.icon className="w-5 h-5 text-brand" />
          </div>
          <h3 className="font-heading font-bold text-lg text-zinc-900">{s.title}</h3>
          <p className="mt-2 text-sm text-zinc-600 leading-relaxed">{s.text}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
